import './assets/main.css'
import 'primeicons/primeicons.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { definePreset } from '@primeuix/themes';
import App from './App.vue'
import router from './router/router'
import { setupAxiosInterceptors } from '@/services/axios'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

import Permissions from './extensions/permissions'

const app = createApp(App)

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        }
    }
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: false || 'none',
        }
    }
});

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(setupAxiosInterceptors)
app.use(pinia)
app.use(router)
app.use(ToastService);
app.use(ConfirmationService);
app.use(Permissions)
app.directive('tooltip', Tooltip);
app.mount('#app')
